import {Injectable} from '@angular/core';
import {Base64} from 'js-base64';
@Injectable()
export class Base64Service {
  constructor() {}

  encode(value: string): string {
    return Base64.encode(value);
  }

  decode(value: string): string {
    return Base64.decode(value);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/service/base64.service.ts